/**
 * Member 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const memberCommonConfig = {
  texts: {
    signIn: 'Sign In',
    myWallet: 'My Wallet',
    coins: 'coins',
    topUp: 'Top Up',
    get: 'Get',
    getVip: 'GET VIP Membership',
    vipMembership: 'VIP Membership',
    moreCoinsMoreBenefits: 'More coins,more benefits',
    expires: 'Expires',
    details: 'Details',
    transactionHistory: 'Transaction History',
    chaptersUnlocked: 'Chapters Unlocked',
    contactUs: 'Contact us',
    setting: 'Setting',
  },
}
